import { render, staticRenderFns } from "./ReservarImovelDialog.vue?vue&type=template&id=39605cbc&"
import script from "./ReservarImovelDialog.vue?vue&type=script&lang=js&"
export * from "./ReservarImovelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports